<div class="mx-5 my-5">
	<nz-result
		[nzTitle]="errorDetails.title"
		[nzStatus]="errorDetails.status"
		[nzSubTitle]="errorDetails.subTitle"
	>
		<div nz-result-extra>
			@if (errorDetails.allowPageRefresh) {
				<button
					nz-button
					nzSize="large"
					[nzType]="
						errorDetails.allowResetSession ? 'default' : 'primary'
					"
					(click)="refetchPage()"
				>
					Genhent side
				</button>
			}
			@if (errorDetails.allowReloadUser) {
				<button
					nz-button
					nzSize="large"
					[nzType]="
						errorDetails.allowResetSession ? 'default' : 'primary'
					"
					(click)="retry()"
				>
					Genhent bruger-profil
				</button>
			}
			@if (errorDetails.allowResetSession) {
				<button
					nz-button
					nzSize="large"
					nzType="primary"
					(click)="reset()"
				>
					Logud
				</button>
			}
		</div>
	</nz-result>
</div>
